import { cx, type ClassValue } from './cx'

export function cn(...inputs: ClassValue[]) {
  return cx(...inputs)
}
